// extracted by mini-css-extract-plugin
export default {"backgroundWrap":"Background_backgroundWrap__oHk7I","background":"Background_background__JsH18","featured":"Background_featured__44oYd","contentWrap":"Background_contentWrap__IZ52N"};